// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1LFUP","content":"Consent_content__3bHq-","footer":"Consent_footer__37KJ1"};